// * import third-party
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronUpIcon } from '@chakra-ui/icons';
import { Badge, Box, Text, Tab, TabList, TabPanel, TabPanels, Tabs, Flex, Button } from '@chakra-ui/react';

// * import local
import ProductBundle from './ProductBundle';
import ProductSatuan from './ProductSatuan';

export default function ProductMapping({ ...props }) {
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState(0);
    const handleTabsChange = (index) => {
        setTabIndex(index);
    };

    const handleViewAll = () => {
        navigate('/upload-mapping-v2/all-mapping', { state: tabIndex });
    };

    return (
        <Box bg={'semantic.100'} boxShadow={'0px 1px 3px 0px #0000001A'} borderRadius={'8px'} p="20px" {...props}>
            <Flex justifyContent={'space-between'} alignItems={'center'} mb={'27px'}>
                <Text fontWeight={'600'} fontSize={'20px'}>
                    Product Mapping
                </Text>
                <Button variant={'link'} onClick={handleViewAll}>
                    Lihat Semua Produk Mapping <ChevronUpIcon fontSize={'20px'} transform={'rotate(90deg)'} />
                </Button>
            </Flex>

            <Tabs index={tabIndex} onChange={handleTabsChange}>
                <TabList>
                    <Tab>Product Satuan</Tab>
                    <Tab>
                        Product Bundle
                        <Badge
                            rounded={'full'}
                            textTransform={'capitalize'}
                            color={'semantic.100'}
                            bg={'danger.500'}
                            p={'4px 6px'}
                            ml={'8px'}
                        >
                            Baru!
                        </Badge>
                    </Tab>
                </TabList>
                <TabPanels>
                    <TabPanel pb={'0'}>
                        <ProductSatuan />
                    </TabPanel>
                    <TabPanel pb={'0'}>
                        <ProductBundle />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}
